/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import {useSelector, TypedUseSelectorHook} from 'react-redux';

import {ApplicationStateInterface} from "@Store";


export const useTypedSelector: TypedUseSelectorHook<ApplicationStateInterface> = useSelector;


export default useTypedSelector;
